<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
    <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
        </v-overlay>

      <v-row class="pa-2" no-gutters v-if="showGatewayPopup">
        <v-col cols="12">
          <qr-edit-gateway
            v-model="showGatewayPopup"
            :sections="gatewaySections"
            :form-data="cardTexts"
            @edit-all="handleEditAll"
            @save="qrUpdate(false)"
            @cancel="onCancel"
          >
            <template v-slot:preview style="position: relative; min-height: 100%;">
              <v-card
                v-if="!res.id"
                class="d-flex align-center justify-center mt-10"
                flat
                min-height="50vh"
              >
                <v-progress-circular indeterminate size="50" width="5" color="gray" />
              </v-card>
              <div v-else class="sticky-preview">
                <view-luck-wheel v-model="cardTexts" :id="res.id" :qr-svg-data-url="qrSvgDataUrl"/>
              </div>
            </template>
          </qr-edit-gateway>
        </v-col>
      </v-row>

      <!-- فرم اصلی و استپر (زمانی که Gateway بسته است) -->
      <v-row class="pa-2" no-gutters v-if="!showGatewayPopup">
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab> {{ $t("view_qr") }}</v-tab>
            <v-tab> {{ $t("preview") }}</v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <!-- پیش‌نمایش سمت چپ -->
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" :svg="svgMade" />
              <v-btn class="btn-download mt-3" @click="showDialog = true">
                <v-icon>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}
              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <view-luck-wheel v-if="res.id" v-model="cardTexts" :id="res.id" :qr-svg-data-url="qrSvgDataUrl"/>
              <div v-else class="text-center py-8">
                <!-- <loading-bet :loading="true" /> -->
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <!-- فرم اصلی -->
        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <!-- مرحله 1 -->
            <v-stepper-step :complete="e6 >= 0" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-12">
                  <p>{{ $t("ROUTE.TITLES.QR_LUCK_WHEEL_Edit") }}</p>
                </div>

                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="res.title"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    :label="$t('luck_wheel_name')"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-title`"
                    :help-data="helpData"
                    :label="$t('luck_wheel_name')"
                    :service-name="serviceName"
                    class="buttoninfo"
                  />
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    v-model="res.identifier"
                    :domain-id="res?.domain_id"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    outlined
                    persistent-hint
                    readonly
                    :key="$t('qrAddressUpdate.hints.allowedChars')"
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"

                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-identifier`"
                    :help-data="helpData"
                    :label="$t('qr_address')"
                    :service-name="serviceName"
                    class="buttoninfo"
                  />
                </div>
              </div>
            </v-stepper-step>

            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12 text-center">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="e6 = 2"
                >
                  {{ $t("next") }}
                </next-btn>
              </div>
            </v-stepper-content>

            <!-- مرحله 2 -->
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="2">
              {{ $t("enter_information") }}
            </v-stepper-step>

            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="mb-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>

                  <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                  </div>
                </div>

              <list-expansion
                v-model="cardTexts"
                :component-name="componentName"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                flat
                @save-required="AutoSave && qrUpdate(false)"

              />

              <div class="row mx-auto mt-6">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 1" />
                </div>
                <div class="col-md-6">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true)"
                  >
                    {{ $t("next") }}
                  </next-btn>
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>

          <!-- QR Canvas مخفی -->
          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>

        <!-- دیالوگ دانلود -->
        <custom-popup
          v-model="showDialog"
          :cons="{ title: $t('download_qr') }"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-download`"
              :help-data="helpData"
              :label="$t('download_qr')"
              :service-name="serviceName"
              class="buttoninfo"
            />
          </template>
          <v-card class="pa-5">
            <download-file-with-api
              v-if="showDialog"
              :address="`${res?.domain?.name||'qrland.in/'}${res?.identifier}`"
              :visit-name="res.visitName"
              @close="showDialog = false"
              :qr_id="res.qrId"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi";
import QrCodeMake from "../../qrland/qrCodeStyle/qrCodeMake";
import ViewLuckWheel from "@/view/pages/otherQrTypes/luckWheel/cm/viewLuckWheel.vue";
import { mapActions } from "vuex";
import { getLanguageCookie } from "@/core/plugins/TitleRibbon/utils/languageCookie";
import { mapGetters } from "vuex";
import loadingBet from "@/view/pages/otherQrTypes/luckWheel/LoadingBet.vue";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "EditLuckWheel",

  components: {
    ViewLuckWheel,
    HelpInfo,
    HelpInfoWrapper,
    QrCodeMake,
    DownloadFileWithApi,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
    QrMaker,
    loadingBet,
    QrEditGateway,
    AtomSpinner
  },

  data: () => ({
    isAutoSaving: false, 
    AutoSave:false,
    showGatewayPopup: false,
    helpData: [],
    serviceName: "Qrland",
    componentName: "luck-wheel-edit",

    e6: 2,
    qrShow: 1,
    svgMade: "",
    showDialog: false,
    loading: false,

    res: {},
    cardTexts: {},
    qrDesign: {},
    qrSvgDataUrl: "",
  }),

  computed: {
    ...mapGetters("localstorage", ["createQrID"]),
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
    fullLink() {
      return `${this.res.domain?.name?.replace("/", "")}/${
        this.res.identifier
      }`;
    },
    specialInfo() {
      return [
        {
          name: "luckWheelInfo",
          title: this.$t("edit_bpage_special_info_special.information"),
          icon: "information-variant-circle-outline",
          model: "info",
        },
        {
          name: "luckWheelManagement",
          title: this.$t("edit_bpage_special_info_special.luck_management"),
          icon: "account-outline",
          model: "prizes",
        },
        {
          name: "luckWheelLogin",
          title: this.$t("edit_bpage_special_info_special.registration_management"),
          icon: "login-variant",
          model: "login",
        },
      ];
    },
    gatewaySections() {
      return this.specialInfo.map((item) => {
        return { ...item, description: item.title };
      });
    },
  },

  created() {
    this.showGatewayPopup = this.$route?.query?.gateway === 'true';
    this.fetchData();
    this.setupEventListeners();
    this.$i18n.locale = getLanguageCookie() || "fa";
  },
  
  beforeDestroy() {
    this.removeEventListeners();
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),

    handleEditAll() {
      this.showGatewayPopup = false;
    },
    
    onCancel() {
      this.$router.push({ name: "qr.list" });
    },

    setupEventListeners() {
      this.$root.$on("setWheelId", this.setWheelId);
      this.$root.$on("savePrize", this.handleSavePrize);
      this.$root.$on("deletePrize", this.handleDeletePrize);
    },

    removeEventListeners() {
      this.$root.$off("setWheelId", this.setWheelId);
      this.$root.$off("savePrize", this.handleSavePrize);
      this.$root.$off("deletePrize", this.handleDeletePrize);
    },

    fetchData() {
      this.loading = true;
      this.$api
        .get(`/v1/testQr/find/${this.domainName}/${this.qrId}`)
        .then((response) => {
          const qr = response.data.data;
          this.setCreatedQrID(qr.id);

          this.res = qr;
          this.cardTexts = {
            ...response.data.data.data.data,
            info: {
              ...response.data.data.data.data.info,
              logo: response.data.data.data.data.info?.logo || "",
            },
            prizes: response.data.data.data.data.prizes || {
              id: null,
              items: [],
            },
            login: response.data.data.data.data.login || {
              requireLogin: false,
              image: "",
            },
          };
          try {
            this.qrDesign = JSON.parse(qr.qr);
          } catch (e) {
            console.warn("خطا در پارس qr settings", e);
            this.qrDesign = {};
          }
          this.setCreatedQrID(qr.id);
          this.$nextTick(() => {
            setTimeout(() => {
              if (this.$refs.qrCanvas && qr.link) {
                this.$refs.qrCanvas.appendCanvas(qr.link);
              }
            }, 500);
          });
          return this.refreshPrizesList();
        })
        .catch((err) => {
          this.$toast.error("خطا در دریافت اطلاعات QR");
          console.error(err);
        })
        .finally(() => {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
          this.loading = false;
        });
    },
    handleSavePrize({ prizeData, prizeId = null }) {
      if (!this.res.id) return;

      const wheelId = this.res.id;
      let request;

      if (prizeId) {
        request = this.$api.put(
          `/v1/testQr/wheels/${wheelId}/prizes/${prizeId}`,
          prizeData,
        );
      } else {
        request = this.$api.post(
          `/v1/testQr/wheels/${wheelId}/prizes`,
          prizeData,
        );
      }

      request
        .then((response) => {
          if (prizeId) {
            this.$toast.success("جایزه با موفقیت ویرایش شد");
          } else {
            this.$toast.success("جایزه با موفقیت اضافه شد");
            if (!this.cardTexts.prizes.id) {
              this.cardTexts.prizes.id =
                response.data.data.id || response.data.data.wheel_id;
            }
          }
          return this.refreshPrizesList();
        })
        .catch((err) => {
          this.$toast.error(
            err.response?.data?.message || "خطا در ذخیره جایزه",
          );
        });
    },

      async handleDeletePrize(prizeId) {
        if (!await this.$modal.yesNo("آیا از حذف این جایزه مطمئن هستید؟")) return;

        try {
          await this.$api.delete(`/v1/testQr/wheels/delete/prize/${this.res.id}`, {
            data: { prize_id: prizeId },
          });

          this.$toast.success("جایزه با موفقیت حذف شد");
          
          this.cardTexts.prizes.items = this.cardTexts.prizes.items.filter(
            (p) => p.id !== prizeId
          );

          if (this.cardTexts.prizes.items.length === 0) {
            this.cardTexts.prizes.id = null;
          }
          
          await this.refreshPrizesList();

        } catch (err) {
          console.error(err);
          this.$toast.error("خطا در حذف جایزه");
        }
      },
          refreshPrizesList() {
      if (!this.res.id) return Promise.resolve();

      return this.$api
        .get(`/v1/testQr/wheels?qr_id=${this.res.id}`)
        .then((response) => {
          const prizes = response.data.data?.prizes;
          if (prizes) {
            this.cardTexts.prizes.items = prizes;
          }
        })
        .catch((err) => {
          console.log("خطا در بارگیری جایزه‌ها:", err);
        });
    },
    setWheelId(id) {
      this.cardTexts.prizes.id = id;
    },

    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const form = new FormData();
      form.append("type", "wheel");
      form.append("image", this.qrSvgDataUrl);
      form.append("qrType", "dynamic");
      form.append("domain", this.res.domain.name);
      form.append("identifier", this.res.identifier);
      form.append("qr_id", this.res.qrId);
      form.append("_method", "PUT");
      form.append("qr", JSON.stringify(this.qrDesign));

      this.cardTexts.language = getLanguageCookie() || "fa";
      form.append("data", JSON.stringify({ theme: "", data: this.cardTexts }));

      this.$api
        .post("/v1/testQr/update", form, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          if(final || !this.AutoSave)
          this.$toast.success("گردونه شانس با موفقیت ویرایش شد");
          if (final) {
             this.$router.push({ name: "qr.list" });
          } else {
             this.refreshPrizesList();
          }
        })
        .catch((err) => {
          this.$toast.error("خطا در ذخیره تغییرات");
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },

    clearDefaults() {
      const name = this.res.title;
      this.cardTexts = {
        visitName: this.cardTexts.visitName || name,
        info: {
          qr_id: null,
          logo: "",
          name: "",
          subtitle: "",
          background_color: "#FFFFFFFF",
          user_limit: 0,
        },
        prizes: { id: this.cardTexts.prizes.id, items: [] },
        login: this.value?.login || {
          requireLogin: false,
          image: "",
        },
      };
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
.sticky-preview {
  position: -webkit-sticky;
  position: sticky;
  top: 0px !important;
  align-self: flex-start;
  height: max-content;
  z-index: 10;
}
</style>
